import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 0.5 },
    delay: { type: Number, default: 0 },
  };

  connect() {
    this.connectedAt = performance.now();
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.observer.disconnect();
          this.timeout = setTimeout(() => this.reveal(), this.remainingDelay);
        }
      },
      { threshold: this.thresholdValue },
    );
    this.observer.observe(this.element);
  }

  reveal() {
    this.element.setAttribute("data-revealed", "");
    this.dispatch("revealed");
  }

  get remainingDelay() {
    return Math.max(
      0,
      this.delayValue - (performance.now() - this.connectedAt),
    );
  }

  disconnect() {
    this.observer.disconnect();
    clearTimeout(this.timeout);
  }
}
